import {useCallback} from 'react'
import {Button, Flex, ModalCloseButton, Text} from '@chakra-ui/react'
import {ChevronLeftIcon} from '@chakra-ui/icons'
import {PropTypes} from 'prop-types'
import {useTranslation} from 'react-i18next'

const Header = ({goToPreviousStep, goToPreviousStepEnabled, title}) => {
  const {t} = useTranslation('invitePayers')

  const handleGoBack = useCallback(() => {
    goToPreviousStep()
  }, [goToPreviousStep])

  return (
    <Flex
      justify={goToPreviousStepEnabled || title ? 'space-between' : 'right'}
      align="center"
      p="sm"
    >
      {goToPreviousStepEnabled ? (
        <Button
          variant="ghost"
          size="sm"
          onClick={handleGoBack}
          leftIcon={<ChevronLeftIcon boxSize="24px" />}
          textTransform="uppercase"
          iconSpacing={1}
          _hover={{bg: 'transparent', color: '#F75E15'}}
        >
          <Text>{t('modal.buttons.back')}</Text>
        </Button>
      ) : (
        <Text pl={2} textTransform="uppercase">
          {title}
        </Text>
      )}
      <ModalCloseButton position="static" />
    </Flex>
  )
}

Header.defaultProps = {
  goToPreviousStep: () => {},
  goToPreviousStepEnabled: false,
  title: '',
}

Header.propTypes = {
  goToPreviousStep: PropTypes.func,
  goToPreviousStepEnabled: PropTypes.bool,
  title: PropTypes.string,
}

export default Header
